import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { InputColor } from 'src/app/interfaces/ui.theme';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
})
export class AutoCompleteComponent {
  @Input() id!: string;
  @Input() label: string = '';
  @Input() suggestions: any[] = [];
  @Input() displayField: string = '';
  @Input() helperText: string = '';
  @Input() placeholder: string = '';
  @Input() multiple: boolean = false;
  @Input('reset') set onCancel(value: boolean) {
    if (value) this.selectedItem = '';
  }
  @Input() color!: InputColor;
  @Input() fullWidth: boolean = false;
  @Input() dense: boolean = false;
  @Input() rounded: boolean = true;

  @Output() sendSearchText = new EventEmitter();
  @Output() sendSelectedItem = new EventEmitter();
  @Output() sendUnselectedItem = new EventEmitter();

  items: any[] = [];

  @Input() selectedItem: any;

  colorClass = {
    error: 'text-error border-error focus:border-red-500',
    success: 'text-green-500 border-green-200 focus:border-green-500',
    warning: 'text-yellow-500 border-yellow-200 focus:border-yellow-500',
  };

  search(event: AutoCompleteCompleteEvent) {
    this.sendSearchText.emit(event);
  }

  onSelect(event: any) {
    this.sendSelectedItem.emit(this.multiple ? this.selectedItem : event.value);
  }

  onUnselect(event: any) {
    this.sendUnselectedItem.emit(
      this.multiple ? this.selectedItem : event.value,
    );
  }
}
